import React from 'react';
import LifehouseAdmMedPdf_Button from "./LifehouseAdmMedPdf_Button";
import LifehouseAdmissionPanel_ButtonWithStatus from "./LifehouseAdmissionPanel_ButtonWithStatus";
import * as modalActions from "../../../store/actions/modal";
import * as actionTypes from "../../../store/actions/actionTypes";
import {useDispatch} from "react-redux";
import {useCustomLogic} from "../../../utils/customLogic";
import {showDocumentFiles} from "../../../store/actions/modal";
import {clinicalFlagScoreButtonClass} from "../../../utils/clinicalFlagColors";

const LifehouseAdmissionPanel_PatMedTd = ({admission}) => {
    const dispatch = useDispatch();
    const {isCustomLogicDemo} = useCustomLogic();

    // Lifehouse reg/hist popups offer the PDF / EMR switch. Whether the PDF side is the clean PDF or the client
    // booklet is set per document type (AdmissionDocumentType.cleanPdf_template) and comes with the document data.
    const pdfModalOptions = {emrPdfToggle: true};

    const showLifeHouseAdmissionInfoModal = () => {
        if (isCustomLogicDemo()) {
            dispatch({
                type: actionTypes.MODAL_ADMISSION_DOCUMENT_PDF_SHOW,
                admissionDocument: actionTypes.ADMISSION_DOCUMENT_ADMISSION_INFO,
                admission: admission
            });
        } else {
            dispatch(modalActions.showAdmRegDiff(admission, '/eRFA-diff', pdfModalOptions));
        }
    }
    const showClinicalFlagsModal = () => dispatch({type: actionTypes.MODAL_CLINICAL_FLAGS_SHOW, admission: admission, ...pdfModalOptions});

    const renderPatientDetails = () => {
        if (admission.lifehouse_admPdfUpload) {
            return <LifehouseAdmMedPdf_Button admission={admission}/>
        } else {
            const showFilesModal = (event) => {
                dispatch(showDocumentFiles(admission.lifehouseFlags_reg.id))
                event.preventDefault();
                event.stopPropagation();
            }
            const hasFiles = (admission.lifehouseFlags_reg && (admission.lifehouseFlags_reg.files_count > 0));
            const counterBadge = hasFiles ?
                <span className="badge-counter" onClick={showFilesModal}>
                        {admission.lifehouseFlags_reg.files_count}
                </span>
                : null;
            return <LifehouseAdmissionPanel_ButtonWithStatus flag={admission.lifehouseFlags_reg}>
                <button onClick={showLifeHouseAdmissionInfoModal} type="button"
                        className={`btn-group-table-button btn btn-success10 text-success ${hasFiles ? "btn-with-badge-counter" : ""}`}>
                    {counterBadge}
                    <span className="icon ico-checkmark"></span>
                </button>
            </LifehouseAdmissionPanel_ButtonWithStatus>;

        }
    }
    const renderMedInfo = () => {
        if (admission.lifehouse_medPdfUpload) {
            return <LifehouseAdmMedPdf_Button admission={admission}/>
        } else {
            return <LifehouseAdmissionPanel_ButtonWithStatus flag={admission.lifehouseFlags_hist}>
                {renderHist(admission.clinicalFlags_summaryRating)}
            </LifehouseAdmissionPanel_ButtonWithStatus>;
        }
    }
    const renderHist = (rating) => {
        const showFilesModal = (event) => {
            dispatch(showDocumentFiles(admission.lifehouseFlags_hist.id))
            event.preventDefault();
            event.stopPropagation();
        }
        const hasFiles = (admission.lifehouseFlags_hist && (admission.lifehouseFlags_hist.files_count > 0));
        const counterBadge = hasFiles ?
            <span className="badge-counter" onClick={showFilesModal}>
                        {admission.lifehouseFlags_hist.files_count}
                </span>
            : null;

        if (rating === undefined) {
            return <button type="button" className={`btn-group-table-button btn btn-gray10 ${hasFiles ? "btn-with-badge-counter" : ""}`}>{counterBadge}-</button>;
        }

        // legacy rating thresholds, kept for flags that carry no configured color
        let fallbackClass;
        if (rating < 3) {
            fallbackClass = "btn-success-light10 text-success-light";
        } else if (rating < 6) {
            fallbackClass = "btn-warning10 text-warning";
        } else {
            fallbackClass = "btn-danger10 text-danger";
        }
        const scoreClass = clinicalFlagScoreButtonClass(admission, fallbackClass);

        return <button onClick={showClinicalFlagsModal} type="button" className={`btn-group-table-button btn ${scoreClass} ${hasFiles ? "btn-with-badge-counter" : ""}`}>{counterBadge}{rating}</button>;
    }

    const dataTipValue = (manager) => {
        if (!manager) {
            return null;
        }
        return `signed by ${manager}`;
    }

    if (admission.lifehouse_medPdfUpload && admission.lifehouse_admPdfUpload) {
        return <td className="lifehouse-adm-list-btn" colSpan={2}><LifehouseAdmMedPdf_Button admission={admission} extraClass="large-btn"/></td>;
    } else {
        return <>
            <td className={`lifehouse-adm-list-btn ${(admission.lifehouseFlags_reg && admission.lifehouseFlags_reg.signedByManager) ? 'red-border' : ''}`} data-tip={dataTipValue(admission.lifehouseFlags_reg ? admission.lifehouseFlags_reg.signedByManager : '')}>{renderPatientDetails()}
            </td>
            <td className={`lifehouse-adm-list-btn ${(admission.lifehouseFlags_hist && admission.lifehouseFlags_hist.signedByManager) ? 'red-border' : ''}`}  data-tip={dataTipValue(admission.lifehouseFlags_hist ? admission.lifehouseFlags_hist.signedByManager : '')}>{renderMedInfo()}</td>
        </>
    }
}

export default LifehouseAdmissionPanel_PatMedTd;